import id from './{id}';
import get from './get';
import query from './query';
import post from './post';

export type PostPayload = {
  allowedRoles?: number[];
  name: string;
  permission: number[];
};
export default { get, id, query, post };
